export default __webpack_public_path__ + "images/multilang-intro-step-2.2f6f586f9adb9f71a54c6e66f5397449.png";